import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { CandidateTypes } from "@/Components/common/client/candidates/CandidateTypes";
import BookedList from "@/Components/common/client/candidates/Listing/BookedList";
import {
  fetchBookedCandidates,
  setBookedCandidatesLoading,
  updatePagination,
  updateFilters,
  deSelectAllCandidate,
} from "@/reducers/client_candidates/candidatesbooked";
import { updateactivePages } from "@/reducers/clientcommon";
import useTitle from "@/utilities/hooks/useTitle";

/**
 * Renders the Booked component.
 *
 * @return {JSX.Element} the rendered Booked component
 */
const Booked = () => {
  useTitle("Booked Candidates");
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesBooked,
  );
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setBookedCandidatesLoading(true));
    dispatch(deSelectAllCandidate());
    dispatch(fetchBookedCandidates());
    dispatch(
      updateactivePages({
        activePage: "candidates",
        activeSubPage: "booked",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
            if (filterObj["listView"]) {
              dispatch(updateListView(filterObj["listView"]));
            }
          }
        },
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <CandidateTypes />
      <BookedList />
    </div>
  );
};

export default Booked;
